export default __webpack_public_path__ + "static/media/icn-philhealth.4d7b1a65.svg";